import { Server } from 'miragejs';
import { RoutesData } from '../model/routes.model';
import { initializeAuthorizationRoutes } from './auth.routes';

export function initializeRoutes(server: Server, routesData: RoutesData): void {
  initializeAuthorizationRoutes(server, routesData.authorizationData);
}
